import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import CONSTANT, { CACHE } from '../../utils/constants';
import { getKey, commas, staticPath, clientMessage, isFunction } from '../../utils/common';
import { onChange } from '../../common/actions';
import { EVENT, log } from '../../common/logger';
import Notification from '../notification';
import { FLOW } from '../../../../common/index.api';
import ConvenienceCharge from '../convenienceChg';
import { UserIcon } from '../userIcon';
import { RupeeSymbol } from '../rupeeSymbol';
import { logoutUser } from '../../controllers/switch-user';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toShowUserDetails: false,
      isLogoLoadedSuccessfully: true
    };
    const locale = clientMessage(CONSTANT.HEADER.toLowerCase(), this.props.cache);
    this.label = locale.label;
    this.error = locale.error;
  }

  showHideUserDetails = (e, toShowUserDetails) => {
    this.setState({ toShowUserDetails: !toShowUserDetails });
    e.stopPropagation();
  };

  headerClickHandle = toShowUserDetails => {
    if (toShowUserDetails) {
      this.setState({ toShowUserDetails: false });
    }
  };

  showSubsDetail = () => {
    this.props.onHelperOverlayToggle(CONSTANT.HELPER_TYPE.SUBS_DETAILS_HELPER);
  };

  closeApplication = () => {
    log({ eventType: EVENT.APP_CLOSE });
    const notifyMerchant = getKey(
      this.props.cache.getData(CACHE.MERCHANT_CONFIG),
      'handler.notifyMerchant',
      undefined
    );
    if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
      notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.APP_CLOSED, {
        message: 'App closed from the header icon'
      });
    }

    const closeHandler = this.props.cache.getData(CACHE.CLOSE_HANDLER);
    isFunction(closeHandler) && closeHandler();
  };

  userLoggedOut = () => {
    const {
      cache,
      checkoutElementPayMode,
      onSelectChange,
      onLoginDataChange,
      onBtnTextChange
    } = this.props;

    logoutUser(cache, checkoutElementPayMode, this.props.subscription, {
      onSelectChange,
      onLoginDataChange,
      onBtnTextChange
    })
      .then(({ isSuccess }) => {
        isSuccess && this.setState({ toShowUserDetails: false });
      })
      .catch(() => {});
  };

  render(
    {
      loginInfo,
      headerFixClass,
      showOtpSent,
      notificationMsg,
      pcfFeeAmount,
      isPcfEnabled,
      subscription,
      cache
    },
    { toShowUserDetails, isLogoLoadedSuccessfully }
  ) {
    let merchantDetails = {};
    let userDetails = {};
    let orderId = '';
    let merchantBrandName = '';
    let merchantNameFromConfig = '';
    let txnAmount = '';
    let logoAvailable = false;
    const merchantConfig = cache.getData(CACHE.MERCHANT_CONFIG);
    if (typeof cache.getData(CACHE.PAYMENT_OPTIONS) === 'object') {
      const paymentOptions = cache.getData(CACHE.PAYMENT_OPTIONS);
      // added empty check so that if merchant details is not found an empty object is there to set values
      merchantDetails = paymentOptions.merchantDetails || {};
      // setting name and logo from merchant config  if it exists instead from api
      merchantNameFromConfig = getKey(merchantConfig, 'merchant.name', null);
      const merchantLogoFromConfig = getKey(merchantConfig, 'merchant.logo', null);
      merchantBrandName = getKey(merchantDetails, 'merchantDisplayName', null);
      if (merchantNameFromConfig) {
        merchantDetails.merchantName = merchantNameFromConfig;
      }
      if (merchantLogoFromConfig) {
        merchantDetails.merchantLogo = merchantLogoFromConfig;
      }
      /* checking that the merchant logo receieved from api is a valid logo */
      logoAvailable = isLogoLoadedSuccessfully && Boolean(merchantDetails.merchantLogo);
      userDetails = paymentOptions.userDetails;
      orderId = getKey(merchantConfig, 'data.orderId', '');
      txnAmount = cache.getData(CONSTANT.TXN_AMOUNT);
      txnAmount === '0' &&
        getKey(subscription, 'isEnabled', false) &&
        (txnAmount = CONSTANT.SUBS_PAYMODE_MIN_AMOUNT);
    }
    return (
      <div
        id="ptm-checkout-header"
        class={`ptm-header ptm-header-bg ptm-pos-a ${headerFixClass ? 'ptm-header_fix' : ''}`}
        ref={headerElem => {
          this.headerElem = headerElem;
        }}
        onClick={() => {
          this.headerClickHandle(toShowUserDetails);
        }}
      >
        <div className={`ptm-header-top`}>
          {!merchantConfig.root && (
            <span className="ptm-cross ptm-pos-r" onClick={() => this.closeApplication()} />
          )}
          <span className={`ptm-select-txt ptm-uppercase ptm-head-select ptm-pos-r ptm-hidden`}>
            {getKey(subscription, 'isEnabled', false)
              ? this.label.subscriptionOption
              : this.label.selectOption}
          </span>
          {loginInfo && loginInfo.userLoggedIn && (
            <div className="ptm-right ptm-pos-r">
              <div
                class={`ptm-user-bg ptm-pos-r ptm-user-box`}
                onClick={e => {
                  this.showHideUserDetails(e, toShowUserDetails);
                }}
              >
                <UserIcon />
              </div>
              {userDetails && (
                <div class={`ptm-user-detail ptm-pos-a ${toShowUserDetails ? '' : 'ptm-hidden'}`}>
                  {userDetails.userName && (
                    <div class={`ptm-user-name`}>{userDetails.userName}</div>
                  )}
                  {userDetails.mobile && <div class={`ptm-user-number`}>{userDetails.mobile}</div>}
                  {/* show logout only when the flow is default */}
                  {merchantConfig.flow === FLOW.DEFAULT && (
                    <div
                      class={`ptm-switch-acc`}
                      id="ptm-switch-account"
                      onClick={() => this.userLoggedOut()}
                    >
                      {this.label.switch}
                      <img
                        src={`${staticPath()}/assets/images/logo-paytm.svg`}
                        alt="paytm"
                        className="ptm-margin0"
                      />
                      {this.label.account}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
        <div class={`ptm-header-bottom`}>
          <div class={`ptm-w100-ib`}>
            {/* To show merchant name and logo only in default flow */}
            {merchantDetails &&
              merchantDetails.merchantLogo &&
              merchantConfig &&
              merchantConfig.flow === FLOW.DEFAULT &&
              logoAvailable && (
                <div class={`ptm-mer-logo ptm-left ptm-pos-r`}>
                  <img
                    class={`ptm-brand-logo ptm-margin0 ptm-pos-a`}
                    src={merchantDetails && merchantDetails.merchantLogo}
                    alt="merchant logo"
                    onError={() => {
                      this.setState({ isLogoLoadedSuccessfully: false });
                    }}
                  />
                </div>
              )}
            {/* To show merchant name only in default flow */}
            {!logoAvailable && merchantConfig && merchantConfig.flow === FLOW.DEFAULT && (
              <div className={`ptm-logo-name ptm-pos-r ptm-fixheader-logo`}>
                <div className={`ptm-logobox ptm-pos-r`}>
                  <img
                    src={`${staticPath()}/assets/images/merc-default.svg`}
                    className={`ptm-centralized`}
                    alt="mer-logo"
                  />
                </div>
              </div>
            )}
            <div class={`ptm-amount ptm-right ptm-amount-color ptm-pos-r`}>
              <span className={`ptm-paytxt ptm-header-color`}>Pay</span>
              <span className={`ptm-header-color`}>
                <RupeeSymbol /> {commas(txnAmount)}
              </span>
            </div>
          </div>
          <div class={`ptm-subheading ptm-header-color ptm-w100-ib`}>
            {/* To show merchant name only in default flow */}

            {
              <span class="ptm-left">
                {merchantConfig && merchantConfig.flow === FLOW.DEFAULT && (
                  <span class={`ptm-name-txt ptm-ellipsis ptm-header-color`}>
                    {/* if merchant name is passed from config show that else show the brandname or
                legal name depending on the availability */}
                    {merchantDetails &&
                      (merchantNameFromConfig || merchantBrandName || merchantDetails.merchantName)}
                  </span>
                )}
                {subscription && subscription.isEnabled && subscription.showDetails && (
                  <div class={`ptm-view-details ptm-header-color`} onClick={this.showSubsDetail}>
                    {this.label.viewSubsDetail}
                    <span className="ptm-arrow-down ptm-arrow-color" />
                  </div>
                )}
              </span>
            }
            {orderId && (
              <span className={`ptm-right  ptm-order-txt ptm-header-color`}>
                {this.label.orderID}: {orderId}
              </span>
            )}
          </div>
          <div class={`ptm-con-wrap ptm-header-color`}>
            {isPcfEnabled && (
              <ConvenienceCharge {...{ pcfFeeAmount }} headerFixClass={headerFixClass} />
            )}
          </div>
        </div>
        {showOtpSent && (
          <p className={`ptm-top-msg ptm-green-bh ptm-pos-a`}>{this.label.otpSend}</p>
        )}
        <div className={`ptm-notify-wrap ptm-pos-a`}>{notificationMsg && <Notification />}</div>
      </div>
    );
  }
}
export default connect(
  'loginInfo, showOtpSent, notificationMsg, cache, checkoutElementPayMode, subscription',
  onChange
)(Header);



// WEBPACK FOOTER //
// ./components/header/index.js